// @ts-nocheck
import React from 'react'
import PropTypes from 'prop-types'
import { colors } from '@lmc/common/constants'
import { ProfilePicture } from '../ProfilePicture'

export default function Tag({
  badgeText,
  badgeColor,
  icon,
  iconColor,
  label,
  onClick,
  picture
}) {
  const shouldDisplayIcon = !!(icon || iconColor || picture)
  return (
    <div onClick={onClick} style={styles.wrapper}>
      {shouldDisplayIcon && (
        <div style={styles.iconWrapper}>
          {renderIcon({ icon, iconColor, picture })}
        </div>
      )}
      <div style={styles.text}>
        {label}
        {badgeText && (
          <div
            style={{
              ...styles.badge,
              background: badgeColor
            }}
          >
            {badgeText}
          </div>
        )}
      </div>
      <div
        className="octicon octicon-x lmc-filter-tag-remove"
        style={styles.removeIcon}
      />
    </div>
  )
}

const renderIcon = ({ icon, iconColor, picture }) => {
  if (picture) {
    return (
      <ProfilePicture url={picture} size={24} style={styles.profilePicture} />
    )
  }
  if (icon || iconColor) {
    return (
      <div
        style={{
          ...styles.iconContainer,
          background: iconColor
        }}
      >
        <img alt="" src={icon} style={styles.icon} />
      </div>
    )
  }
  return null
}

const styles = {
  badge: {
    fontWeight: 'bold',
    display: 'inline-block',
    marginLeft: 5,
    padding: '0px 4px',
    borderRadius: 15
  },
  icon: {
    width: 10
  },
  iconContainer: {
    alignItems: 'center',
    borderRadius: 24,
    display: 'flex',
    flexShrink: 0,
    justifyContent: 'center',
    height: 24,
    width: 24
  },
  iconWrapper: {
    padding: '2px 4px 2px 2px'
  },
  profilePicture: {
    flexShrink: 0
  },
  text: {
    color: colors.black,
    fontSize: 12,
    padding: 3,
    display: 'flex',
    alignItems: 'center'
  },
  removeIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: 4,
    padding: '0 4px'
  },
  wrapper: {
    alignItems: 'center',
    background: colors.buttongrey,
    borderRadius: 20,
    cursor: 'pointer',
    display: 'flex',
    margin: 2,
    minWidth: 0,
    userSelect: 'none',
    padding: 3,
    paddingLeft: 10
  }
}
Tag.propTypes = {
  badgeColor: PropTypes.string,
  badgeText: PropTypes.string,
  icon: PropTypes.string,
  iconColor: PropTypes.string,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  picture: PropTypes.string
}
